import * as React from 'react';
import PhotographerProductForm from '../../PhotographerProductForm';

const PhotographerFormComponentProducts = (props: any) => {
    return (
        <PhotographerProductForm
            products={props.products}
            productAdded={props.productAdded}
            productRemoved={props.productRemoved}
            user={props.user}
            onCheckboxChange={props.onCheckboxChange}
            site={props.site}
        />
    );
};

export default PhotographerFormComponentProducts;
